namespace $ {
	export class $shm_hitalama_guide_group extends $giper_baza_entity.with({ Parent: $giper_baza_atom_text }) {}
}
